const initHiddenItems = () => {
  const hiddenToggles = document.querySelectorAll('[data-hidden-items-btn]');

  if (!hiddenToggles.length) {
    return;
  }

  hiddenToggles.forEach((it) => {
    const btnParent = it.closest('[data-hidden-items]');
    const hiddenItems = btnParent.querySelectorAll('[data-hidden-item]');

    it.addEventListener('click', (evt) => {
      const target = evt.currentTarget;

      target.classList.toggle('is-hide');
      btnParent.classList.toggle('is-active');

      hiddenItems.forEach((btn) => {
        btn.classList.toggle('is-hidden');
      });
    });
  });
};

export {initHiddenItems};
